(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const all = (selector, root = document) => [...root.querySelectorAll(selector)];
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = $('.site-header');
  const menu = $('#SiteNavigation');
  const toggle = $('.menu-toggle');
  const backdrop = $('.lf-menu-backdrop');
  const mobile = matchMedia('(max-width: 989px)');
  let menuOpen = false;
  let previousFocus;
  function closeDetails(except) {
    all('.lf-navigation details[open]').forEach(el => { if (el !== except) el.open = false; });
  }
  function setMenu(open, restore = true) {
    menuOpen = open && mobile.matches;
    menu?.classList.toggle('open', menuOpen);
    document.body.classList.toggle('lf-menu-open', menuOpen);
    toggle?.setAttribute('aria-expanded', String(menuOpen));
    toggle?.setAttribute('aria-label', menuOpen ? 'Sluit menu' : 'Open menu');
    if (backdrop) backdrop.hidden = !menuOpen;
    if (menu) {
      menu.inert = mobile.matches && !menuOpen;
      if (mobile.matches && !menuOpen) menu.setAttribute('aria-hidden', 'true');
      else menu.removeAttribute('aria-hidden');
    }
    all('#MainContent, .site-footer').forEach(el => { el.inert = menuOpen; });
    if (menuOpen) {
      previousFocus = document.activeElement;
      header?.classList.remove('is-hidden');
      $('a, summary, button', menu)?.focus();
    } else {
      closeDetails();
      if (restore && previousFocus?.isConnected) previousFocus.focus();
    }
  }
  toggle?.addEventListener('click', () => setMenu(!menuOpen));
  backdrop?.addEventListener('click', () => setMenu(false));
  mobile.addEventListener('change', () => setMenu(false, false));
  setMenu(false, false);
  menu?.addEventListener('click', event => {
    if (event.target.closest('a') && menuOpen) setMenu(false, false);
  });
  all('.lf-navigation details').forEach(details => details.addEventListener('toggle', () => {
    if (details.open) closeDetails(details);
  }));
  document.addEventListener('click', event => {
    if (!event.target.closest('.lf-navigation')) closeDetails();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (menuOpen) setMenu(false);
      else {
        const expanded = $('.lf-navigation details[open]');
        if (expanded) { expanded.open = false; $('summary', expanded).focus(); }
      }
    }
    if (event.key === 'Tab' && menuOpen) {
      const elements = [toggle, ...all('a, button, summary, input', menu)].filter(el => el && el.getClientRects().length);
      const index = elements.indexOf(document.activeElement);
      event.preventDefault();
      const next = (index + (event.shiftKey ? -1 : 1) + elements.length) % elements.length;
      elements[next]?.focus();
    }
  });
  let lastY = scrollY, scrollQueued = false;
  const showHeader = () => header?.classList.remove('is-hidden');
  addEventListener('scroll', () => {
    if (scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(() => {
      const y = Math.max(0, scrollY);
      if (y < lastY || y < 100 || menuOpen || header?.contains(document.activeElement)) showHeader();
      else if (y > lastY && y > 150) header?.classList.add('is-hidden');
      header?.classList.toggle('is-scrolled', y > 12);
      lastY = y;
      scrollQueued = false;
    });
  }, { passive: true });
  addEventListener('wheel', event => { if (event.deltaY < 0) showHeader(); }, { passive: true });
  let touchY = null;
  addEventListener('touchstart', event => { touchY = event.touches[0]?.clientY; }, { passive: true });
  addEventListener('touchmove', event => {
    const y = event.touches[0]?.clientY;
    if (y > touchY) showHeader();
    touchY = y;
  }, { passive: true });
  header?.addEventListener('focusin', showHeader);

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-qty]');
    if (button) {
      const input = $('input', button.closest('.quantity'));
      if (input) {
        const min = Number(input.min || 1), step = Number(input.step || 1);
        const max = input.max ? Number(input.max) : Infinity;
        input.value = String(Math.max(min, Math.min(max, (Number(input.value) || min) + Number(button.dataset.qty) * step)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const tracked = event.target.closest('[data-track]');
    if (tracked) document.dispatchEvent(new CustomEvent('letsfil:interaction', { detail: { action: tracked.dataset.track, page: location.pathname } }));
  });

  function init(root = document) {
    all('[data-gallery]', root).forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = $('.lf-gallery-track', gallery);
      const buttons = all('[data-gallery-index]', gallery);
      let scheduled = false;
      buttons.forEach(button => button.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * Number(button.dataset.galleryIndex), behavior: reducedMotion() ? 'instant' : 'smooth' })));
      track.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
          all('video', gallery).forEach(video => { if (video.closest('.lf-gallery-slide') !== track.children[index]) video.pause(); });
          scheduled = false;
        });
      }, { passive: true });
    });
    all('[data-product-root]', root).forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const variants = JSON.parse($('[data-variant-data]', product).textContent);
      const form = $('.lf-product-form', product);
      if (!form) return;
      const variantInput = $('[data-variant-select]', form);
      const planSelect = $('[data-plan-select]', form);
      const quantity = $('[name="quantity"]', form);
      let lastVariant = null;
      const update = (replaceUrl = false) => {
        const variant = variants.find(v => String(v.id) === variantInput.value);
        if (!variant) return;
        const changed = String(lastVariant) !== String(variant.id);
        if (planSelect && changed) {
          const oldPlan = planSelect.value;
          planSelect.replaceChildren();
          if (!variant.requiresPlan) planSelect.add(new Option('Eenmalig · ' + variant.money, ''));
          variant.plans.forEach(plan => planSelect.add(new Option(plan.name + ' · ' + plan.money, String(plan.id))));
          if (variant.plans.some(plan => String(plan.id) === oldPlan)) planSelect.value = oldPlan;
          planSelect.required = Boolean(variant.requiresPlan);
          planSelect.disabled = !variant.plans.length;
          $('[data-plan-field]', product).hidden = !variant.plans.length;
        }
        const planInput = form.elements.namedItem('selling_plan');
        const selectedPlan = variant.plans.find(p => String(p.id) === String(planInput?.value));
        const price = selectedPlan || variant;
        $('[data-price]', product).textContent = price.money;
        const stickyPrice = $('[data-sticky-price]', product);
        if (stickyPrice) stickyPrice.textContent = price.money;
        const compare = $('[data-compare]', product);
        if (compare) {
          const bundle = compare.dataset.bundleCompare;
          const amount = bundle ? Number(bundle) : variant.compare;
          compare.hidden = !(amount > price.price);
          if (!bundle) $('s', compare).textContent = variant.compareMoney;
        }
        const planLabel = $('[data-plan-price]', product);
        if (planLabel) planLabel.textContent = selectedPlan ? selectedPlan.name : '';
        const description = $('[data-plan-description]', product);
        if (description) description.textContent = selectedPlan ? [selectedPlan.description, 'Bij afrekenen: ' + selectedPlan.checkout + '. Per levering: ' + selectedPlan.perDelivery + '.'].filter(Boolean).join(' ') : '';
        if (changed) {
          quantity.min = variant.min; quantity.step = variant.step;
          if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
          const current = Math.max(variant.min, Number(quantity.value) || variant.min);
          quantity.value = Math.min(variant.max || Infinity, variant.min + Math.ceil((current - variant.min) / variant.step) * variant.step);
          if (lastVariant && variant.media) {
            const slide = $('[data-media-id="' + variant.media + '"]', product);
            const track = $('.lf-gallery-track', product);
            if (slide && track) track.scrollTo({ left: [...track.children].indexOf(slide) * track.clientWidth, behavior: 'instant' });
          }
        }
        const validPlan = !variant.requiresPlan || Boolean(selectedPlan) || !planSelect;
        all('[data-primary-buy], [data-sticky-button]', product).forEach(button => {
          button.disabled = !variant.available || !validPlan;
          button.textContent = !variant.available ? 'Uitverkocht' : !validPlan ? 'Kies een aankoopoptie' : product.dataset.ctaLabel;
        });
        if (replaceUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          if (selectedPlan) url.searchParams.set('selling_plan', selectedPlan.id); else url.searchParams.delete('selling_plan');
          history.replaceState({}, '', url);
        }
        lastVariant = variant.id;
      };
      form.addEventListener('change', event => { if (event.target.name === 'id' || event.target.name === 'selling_plan') update(true); });
      update();
    });
    all('video[data-track]', root).forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      video.addEventListener('play', () => document.dispatchEvent(new CustomEvent('letsfil:interaction', { detail: { action: 'video-play', page: location.pathname } })));
    });
    all('[data-v1-usp]', root).forEach(component => {
      if (component.dataset.ready) return;
      component.dataset.ready = 'true';
      const buttons = all('[data-v1-usp-button]', component);
      const activate = index => {
        buttons.forEach((button, i) => { button.classList.toggle('is-active', i === index); button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; });
        ['image', 'panel'].forEach(type => all('[data-v1-usp-' + type + ']', component).forEach((el, i) => el.classList.toggle('is-active', i === index)));
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          activate(next); buttons[next].focus();
        });
      });
      activate(0);
    });
    all('[data-exploded-filter]', root).forEach(component => {
      if (component.dataset.ready) return;
      component.dataset.ready = 'true';
      const titles = ['Beschermhuls', 'Filterkern', 'Aansluiting', 'Waterinlaat', 'Exacte passing'];
      const copies = ['Houdt de filterkern op zijn plek in de fles.', 'Helpt ongewenste smaken en geuren verminderen. Vervang na ongeveer twee maanden, afhankelijk van gebruik.', 'Verbindt de filtermodule met de Letsfil V1.', 'Het water stroomt door het filter terwijl je drinkt.', 'De onderdelen passen samen in de Letsfil V1. Je houdt de fles en vervangt het filter.'];
      all('[data-exploded-choice]', component).forEach(button => button.addEventListener('click', () => {
        const index = Number(button.dataset.explodedChoice);
        all('[data-exploded-choice]', component).forEach(el => { const active = Number(el.dataset.explodedChoice) === index; el.classList.toggle('is-active', active); el.setAttribute('aria-pressed', String(active)); });
        all('[data-exploded-line]', component).forEach(el => el.classList.toggle('is-active', Number(el.dataset.explodedLine) === index));
        [['kicker', String(index + 1).padStart(2, '0') + ' · ' + titles[index]], ['title', titles[index]], ['copy', copies[index]]].forEach(([key, text]) => { const el = $('[data-exploded-' + key + ']', component); if (el) el.textContent = text; });
      }));
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  let stickyQueued = false;
  function updateSticky() {
    stickyQueued = false;
    const obscured = menuOpen || all('dialog[open], cart-drawer[open], cart-drawer.active, [data-cart-drawer][aria-hidden="false"], #shopify-pc__banner, .shopify-pc__banner__dialog, [data-cookie-banner], .cc-window:not(.cc-invisible)').some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    let visible = false;
    all('[data-sticky-buy]').forEach(bar => {
      const primary = $('[data-primary-buy]', bar.closest('[data-product-root]'));
      const show = mobile.matches && !obscured && primary?.getBoundingClientRect().bottom < 0;
      if (bar.hidden === show) bar.hidden = !show;
      visible ||= Boolean(show);
    });
    all('[data-landing-sticky]').forEach(bar => {
      const primary = $('[data-landing-primary]');
      const offer = $('#starter-deal-offer');
      const rect = offer?.getBoundingClientRect();
      const offerVisible = rect && rect.top < innerHeight && rect.bottom > 0;
      const show = mobile.matches && !obscured && primary?.getBoundingClientRect().bottom < 0 && !offerVisible;
      if (bar.hidden === show) bar.hidden = !show;
      visible ||= Boolean(show);
    });
    document.body.classList.toggle('lf-sticky-visible', visible);
  }
  const queueSticky = () => { if (!stickyQueued) { stickyQueued = true; requestAnimationFrame(updateSticky); } };
  addEventListener('scroll', queueSticky, { passive: true });
  addEventListener('resize', queueSticky, { passive: true });
  new MutationObserver(queueSticky).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'open', 'aria-hidden', 'style'] });
  queueSticky();
})();
